//!!! Using dangerouslySetInnerHTML for desc!!!!

export const trainingProjects = [
    {
        name: "Where it started",
        desc: "This is my first repo to Github. It is here to remind me how far I've come along. It is the literal definition of <em>It ain't much but it's honest work.</em>",
        img: "first-repo.jpg",
        gh: 'https://github.com/DanielRendon1020/Send_it',
        link: 'https://danielrendon1020.github.io/Send_it/',
        langs: ['html']
      },
      {
        name: "HTML Form",
        desc: "Getting a bit more comfortable with HTML and CSS. This is a simple form that has a sprinkle of JS.",
        img: "html-form.jpg",
        gh: 'https://github.com/DanielRendon1020/HTML-Improved-Form',
        link: 'https://danielrendon1020.github.io/HTML-Improved-Form/',
        langs: ['html', 'css', 'javascript']
      },
      {
        name: "CSS Notepad",
        desc: "Replicating different presented styles with  some basic CSS.",
        img: "css-notepad.jpg",
        gh: 'https://github.com/DanielRendon1020/UncleStickiesNotepadEmporium',
        link: 'https://danielrendon1020.github.io/UncleStickiesNotepadEmporium/',
        langs: ['css', 'html']
      },
      {
        name: "Mini-Game",
        desc: "This mini game evolved and covered most functionalities of JS from callbacks, promises, async/await, and event listeners.",
        img: "mini-game.jpg",
        gh: 'https://github.com/DanielRendon1020/Async-await-Web-Game-Part-7',
        link: 'https://danielrendon1020.github.io/Async-await-Web-Game-Part-7/',
        langs: ['javascript', 'html']
      },
      {
        name: "Whack-a-Tag",
        desc: "For this project, I decided to create a browser game that wrapped up what I'd learned using the core languages.",
        img: "whack-a-tag.jpg",
        gh: 'https://github.com/DanielRendon1020/Browser-game-v1',
        link: 'https://danielrendon1020.github.io/Browser-game-v1/',
        langs: ['javascript', 'bootstrap', 'html', 'css']
      },
      {
        name: "BreadCRUD",
        desc: "Some practice with CRUD operations with MonogoDB and Node.js.",
        img: "breadcrud.jpg",
        gh: 'https://github.com/DanielRendon1020/breads',
        link: '',
        langs: ['javascript', 'mongodb', 'html', 'css']
      },
      {
        name: "RestRANT",
        desc: "This application went hand-and-hand with BreadCRUD and wrapped up backend and APIs.",
        img: "restrant.jpg",
        gh: 'https://github.com/DanielRendon1020/project-REST-RANT',
        link: '',
        langs: ['javascript', 'mongodb', 'html', 'css']
      },
      {
        name: "React-A-Mole",
        desc: "Dipping in my toe with React using useState and useEffect in yet another whack-a-mole game.",
        img: "react-a-mole.jpg",
        gh: 'https://github.com/DanielRendon1020/react-a-mole',
        link: 'https://danielrendon1020.github.io/react-a-mole/',
        langs: ['react', 'javascript']
      },
      {
        name: "Monty's Mineral SPA",
        desc: "Getting to know React-Router-Dom and React-Bootstrap.",
        img: "montys-mineral-spa.jpg",
        gh: 'https://github.com/DanielRendon1020/React-Router-Montys-Mineral-Spa-Solution',
        link: 'https://danielrendon1020.github.io/React-Router-Montys-Mineral-Spa/',
        langs: ['react', 'bootstrap']
      },
      {
        name: "React-Redux",
        desc: "First time using Redux to manage state making a simple counter and To-Do list.",
        img: "react-redux.jpg",
        gh: 'https://github.com/DanielRendon1020/first-react-redux',
        link: 'https://danielrendon1020.github.io/first-react-redux/',
        langs: ['react', 'redux', 'javascript']
      },
      {
        name: "Sequelizers Apparel",
        desc: "PERN project using Sequelize to manage database and CRUD operations. Also first deployment!",
        img: "sequelizers-apparel.jpg",
        gh: 'https://github.com/DanielRendon1020/PERN-Project',
        link: 'https://sequelizers-apperal.onrender.com/',
        langs: ['postgresql', 'express', 'react', 'nodejs']
      },
      
    ]